import {connect} from 'react-redux';

import Base from './Base';

const Stop = props => <Base {...props} id="stop" />;

const mapStateToProps = ({animationStop: index}) => ({index});

export default connect(mapStateToProps)(Stop);
